import React from 'react';
import styled from 'styled-components';
import metricsStore from '../../../../stores/metrics.store';
import BaseChart from './chart/BaseChart';

const ServerDashboardChartsStyled = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  padding: 1px 10px;
  margin-top: 0;
  grid-gap: 11px;

  @media (max-width: 1025px) {
    grid-template-columns: 1fr;
  }
`;

const ServerItemChart = props => {
    const { server, cpu, disk, disk_io, net, ram, connections, processes, file_handles, sessions, sinceSelected, isLoading } = props;

    const handleSelectChange = e => {
        metricsStore.setSince(e.target.value, server._id);
    };

    return (
        <ServerDashboardChartsStyled>
            { server && server.serverData.agentPushedTheData && (
                <>
                    <BaseChart
                        title="CPU"
                        icon="compute"
                        isLoading={ isLoading }
                        selected={ sinceSelected }
                        handleSelectChange={ handleSelectChange }
                        data={ cpu }
                        description="CPU utilization percentage across all cores, representing active processing load."
                    />

                    <BaseChart
                        title="Memory"
                        icon="memory"
                        isLoading={ isLoading }
                        selected={ sinceSelected }
                        handleSelectChange={ handleSelectChange }
                        data={ ram }
                        description="System memory (RAM) utilization, showing active memory consumption in gigabytes or percentage."
                    />

                    <BaseChart
                        title="Network"
                        icon="globe"
                        isLoading={ isLoading }
                        selected={ sinceSelected }
                        handleSelectChange={ handleSelectChange }
                        data={ net }
                        description="Network data throughput, displaying incoming (RX) and outgoing (TX) traffic rates in bytes/sec."
                    />

                    <BaseChart
                        title="Disk"
                        isLoading={ isLoading }
                        icon="storage"
                        selected={ sinceSelected }
                        handleSelectChange={ handleSelectChange }
                        data={ disk }
                        description="Disk storage capacity utilization, showing used space on mounted file systems."
                    />

                    { disk_io && (
                        <BaseChart
                            title="Disk I/O"
                            isLoading={ isLoading }
                            icon="visMapCoordinate"
                            selected={ sinceSelected }
                            handleSelectChange={ handleSelectChange }
                            data={ disk_io }
                            description="Disk input/output activity, tracking read and write operation throughput on storage devices."
                        />
                    ) }

                    <BaseChart
                        title="Connections"
                        isLoading={ isLoading }
                        icon="globe"
                        selected={ sinceSelected }
                        handleSelectChange={ handleSelectChange }
                        data={ connections }
                        description="Total active network connections (sockets) currently open on the server."
                    />

                    <BaseChart
                        title="Processes"
                        isLoading={ isLoading }
                        icon="createPopulationJob"
                        selected={ sinceSelected }
                        handleSelectChange={ handleSelectChange }
                        data={ processes }
                        description="Number of concurrent operating system processes and threads currently running."
                    />

                    <BaseChart
                        title="File Handles"
                        isLoading={ isLoading }
                        icon="filebeatApp"
                        selected={ sinceSelected }
                        handleSelectChange={ handleSelectChange }
                        data={ file_handles }
                        description="Number of allocated file descriptors/handles compared to the system limit."
                    />

                    <BaseChart
                        title="Sessions"
                        isLoading={ isLoading }
                        icon="sessionViewer"
                        selected={ sinceSelected }
                        handleSelectChange={ handleSelectChange }
                        data={ sessions }
                        description="Number of active user login sessions (SSH, local console, etc.) on the server."
                    />
                </>
            ) }
        </ServerDashboardChartsStyled>
    );
};

export default ServerItemChart;